module.exports = __webpack_public_path__ + "img/menu.0fa56716.svg";